/**
 * @module  support/shared/widgets
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-any no-global-variables */
import { Component, Input, OnDestroy } from '@angular/core';

/**
 * A T-mobile customm design spinner component.
 */

@Component({
  selector: 'tmo-inline-spinner',
  templateUrl: './inline-spinner.component.html',
  styleUrls: ['../../../../../../style-sheets/components/html-spinner.component.scss'],
})
export class InlineSpinnerComponent implements OnDestroy {
  /**
   * Numneric input property to set the delay time
   */
  @Input() public delay: number;

  /**
   * Centers spinner inside its relative container
   *
   * @type {boolean}
   * @memberof InlineSpinnerComponent
   */
  @Input() public textCenter: boolean;

  /** This flag will be passed from the parent component to hide/display the spinner */
  public showSpinner: boolean;

  /** To set the value of showSpinner  */
  private toggleValue: boolean;

  /** To set the value of showSpinner  */
  private timeOutTimer: any;

  constructor() {
    this.showSpinner = true;
  }

  /**
   * Destroys all the subsciptions.
   * @returns void
   */
  public ngOnDestroy(): void {
    clearTimeout(this.timeOutTimer);
  }
  /**
   * Use to set the delay to spinner component
   */
  @Input()
  public set setDelay(value: boolean) {
    this.toggleValue = value;
    if (this.toggleValue) {
      this.showSpinner = this.toggleValue;
    } else {
      this.timeOutTimer = setTimeout(() => {
        this.showSpinner = this.toggleValue;
      }, this.delay);
    }
  }
}
